import PersonIcon from '@mui/icons-material/Person';
import RadarIcon from '@mui/icons-material/Radar';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MapIcon from '@mui/icons-material/Map';
import ForumIcon from '@mui/icons-material/Forum';

export const PASSPORT_NAV_ITEMS = [
  {
    id: 'passport',
    path: '/passport/me',
    icon: PersonIcon,
    label: 'My Passport',
    shortLabel: 'Passport',
    shortKey: 'gigPassport.nav.passportShort',
    exact: true
  },
  {
    id: 'radar',
    path: '/passport/radar',
    icon: RadarIcon,
    label: 'Signal Radar',
    shortLabel: 'Radar',
    shortKey: 'gigPassport.nav.radarShort',
    exact: true
  },
  {
    id: 'communications',
    path: '/passport/communications/community',
    activePath: '/passport/communications',
    icon: ForumIcon,
    label: 'Communications',
    shortLabel: 'Messages',
    shortKey: 'gigPassport.nav.communicationsShort',
    exact: false
  },
  {
    id: 'events',
    path: '/passport/events',
    icon: CalendarTodayIcon,
    label: 'Events',
    shortLabel: 'Events',
    shortKey: 'gigPassport.nav.eventsShort',
    exact: true
  },
  {
    id: 'cities',
    path: '/passport/cities',
    icon: MapIcon,
    label: 'City Nodes',
    shortLabel: 'Cities',
    shortKey: 'gigPassport.nav.citiesShort',
    exact: true
  }
];
